import gql from "graphql-tag";

export const accountPermissionGql = gql`
  query AccountPermission($filter: AccountPermissionInput!) {
    accountPermission(filter: $filter) {
      __typename
      ... on ResponseErrors {
        errors {
          __typename
          code
          message
        }
      }
      ... on AccountPermissionDetailList {
        details {
          productName
          productType
          productCurrencies
        }
      }
    }
  }
`;
